import { Lightning, Log } from '@lightningjs/sdk'
import { Helper } from '../../lib/helper'
import ParentalButton from '../../ui-elements/parental-button'

export default class GetCodeFacebook extends Lightning.Component {

    polingIntv: any
    codeData: any
    interval = 0
    accessToken: any
    status = 'waiting'
    instructions = (uri) => `Next, visit ${uri} on your desktop or smartphone and enter this code`
    userCode = (code) => `USER CODE: ${code}`
    abortAjax: any

    static override _template() {
        return {
            w: 1920,
            h: 1080,
            color: 0xff000000,
            Container: {
                x: (w) => w / 2,
                y: (h) => h / 2,
                mount: 0.5,
                w: 1000,
                h: 400,
                rect: true,
                color: 0xff000000,
                flex: { direction: 'column', margin:10},
                Title: {
                    //flex: { direction: 'row', justifyContent: 'space-between', alignItems:'center'},
                    w:1000, 
                    h:90,
                    Label: {
                        y:20,
                        x:20,
                        text: { text: 'Log in with Facebook', fontSize: 30, fontFace: Helper.getFontFamily('Regular'), textColor: 0xffffffff }
                    },
                    Expires: {
                        y:20,
                        x: 960,
                        mountX:1,
                        text: { text: '', fontSize: 30, fontFace: Helper.getFontFamily('Regular'), textColor: 0xffffffff }
                    },
                },
                Body: {
                    rect: true,
                    color: 0xff222222,
                    w: (w) => w,
                    h: 400,
                    flex: { direction: 'column', margin:10},
                    Instruction: {
                        y:20, x:20,
                        h: 80,
                        text: { text: 'Loading ...', fontSize: 24, fontFace: Helper.getFontFamily('Regular'), textColor: 0xffffffff, wordWrapWidth: 900, maxLines: 2 }
                    },
                    Usercode: {
                        x:20,
                        y:60,
                        h: 60,
                        text: { text: '', fontSize: 40, fontFace: Helper.getFontFamily('Regular'), textColor: 0xffffffff }
                    },
                    ButtonWrapper: {
                        y: 80,
                        h: 90,
                        flexItem: { alignSelf: 'center'},
                        CreateBtn: {
                            mount: 0.5,
                            type: ParentalButton,
                            label: 'Continue to create pin',
                            icon: null,
                            w: 400
                        },
                        visible: false,
                    }
                }
            },
        }
    }

    override _init(): void {
        this.getFacebookCode()
    }

    updateScreen() {
        const { verification_uri, user_code, interval, expires_in } = this.codeData

        this.tag('Instruction').text.text = this.instructions(verification_uri)
        this.tag('Usercode').text.text = this.userCode(user_code)
        this.startPolingTimer(interval, expires_in)
    }

    getFacebookCode() {
        this.tag('Instruction').text.text = 'Loading ...'
        this.tag('Usercode').text.text = ''
        this.tag('Expires').text.text = ''
        this.abortAjax = $.ajax({
            type: "POST",
            url: 'https://graph.facebook.com/v2.6/device/login',
            data: "access_token=1116370178919727|845780eff189376fc9bbecbd0b8db21c&scope=public_profile",
            dataType: "text",
            cache: false,
            beforeSend: () => {
                //helper.preloaderDisplay('show');
            },
            success: (data) => {
                this.codeData = JSON.parse(data)
                this.updateScreen()
            }
        });

    }

    updateSuccess(data) {
        this.tag('Label').text.text = 'Welcome ' + data.name
        this.tag('Instruction').text.text = 'Press Ok to create PIN'
        //this.tag('CreateBtn').text.text = 'Continue to create pin'
        this.tag('ButtonWrapper').visible = true
        this.tag('Usercode').text.text = ''
        this.tag('Expires').text.text = ''
        this.status = 'success'
    }

    startPolingTimer(interval, expires) {
        let secCnt = 0
        this.polingIntv = setInterval(() => {
            secCnt++;
            this.tag('Expires').text.text = `Expires in ${Helper.secondsToDisplayReadyTime(expires - secCnt)}`
            if (secCnt % interval == 0) {
                $.ajax({
                    type: "POST",
                    url: 'https://graph.facebook.com/v2.6/device/login_status',
                    data: "access_token=1116370178919727|845780eff189376fc9bbecbd0b8db21c&code=" + this.codeData.code,
                    dataType: "text",
                    cache: false,
                    beforeSend: function () {

                    },
                    success: (data) => {
                        var resp = JSON.parse(data);
                        if (resp.error) {
                            //Log.info('waiting for User : ',resp)
                            if (resp.error.code == 463) {
                                Log.info('waiting for User : ', resp)
                                this.stopPolingTimer()
                                this.signal('codeScreen')
                            }
                        } else {
                            this.accessToken = resp.access_token;
                            this.getFacebookDetails();
                            this.stopPolingTimer();
                        }
                    },
                    error: function (e) {
                        console.log('error: ' + e);
                    }
                });
            }
        }, (1000));
    }

    stopPolingTimer() {
        clearInterval(this.polingIntv);
    }

    getFacebookDetails() {
        $.ajax({
            type: "GET",
            url: 'https://graph.facebook.com/v2.3/me?access_token=' + this.accessToken + '&fields=name',
            dataType: "text",
            cache: false,
            beforeSend: function () {

            },
            success: (data) => {
                var resp = JSON.parse(data);
                Log.info('profile: ', resp);
                this.updateSuccess(resp)
                // //const successText = this.getProfileTemplate(resp.name);
                // $('#code-screen-wrapper').empty();
                // $('#code-screen-wrapper').append(successText);

            },
            error: function (e) {
                console.log('error: ' + e);
            }
        });
    }

    override _handleKey(e: KeyboardEvent): boolean | void {
        return true
    }

    override _handleBack(e: KeyboardEvent): boolean | void {
        this.signal('back')
        return true
    }

    override _getFocused(): Lightning.Component | null | undefined {
        return this.tag('CreateBtn')
    }

    override _handleEnter(e: KeyboardEvent): boolean | void {
        if (this.status == 'success') {
            this.signal('createPin')
        }
        return true
    }

    _handleClick(e: KeyboardEvent): boolean | void {
        if (this.status == 'success') {
            this.signal('createPin')
        }
        return true
    }

    override _detach(): void {
        this.abortAjax && this.abortAjax.abort()
        this.stopPolingTimer()
    }

}